import { AuthGroup } from 'root/src/server/util/awsClients/authApiClient.types';
import { getCookies } from 'root/src/client/v2/browser/helpers/cookies';
import jwtDecode from 'jwt-decode';
import { isLocalhost, isLocalEnv } from 'root/src/shared/util/envSelect';
/**
 * Helper class with most common methods for server side props
 */
export class ServerSidePropsContext {
    constructor(ctx) {
        this.cookies = {};
        this.ctx = ctx;
        this.buildCookies();
    }
    buildCookies() {
        var _a, _b, _c, _d, _e, _f, _g;
        const cookieString = ((_c = (_b = (_a = this.ctx) === null || _a === void 0 ? void 0 : _a.req) === null || _b === void 0 ? void 0 : _b.headers) === null || _c === void 0 ? void 0 : _c.Cookie) || ((_f = (_e = (_d = this.ctx) === null || _d === void 0 ? void 0 : _d.req) === null || _e === void 0 ? void 0 : _e.headers) === null || _f === void 0 ? void 0 : _f.cookie);
        this.cookies = (_g = getCookies(cookieString)) !== null && _g !== void 0 ? _g : {};
    }
    getAuthToken() {
        var _a, _b, _c, _d;
        return (_c = (_b = (_a = this.ctx.req) === null || _a === void 0 ? void 0 : _a.session) === null || _b === void 0 ? void 0 : _b.accessToken) !== null && _c !== void 0 ? _c : (_d = this.cookies) === null || _d === void 0 ? void 0 : _d.accessToken;
    }
    getUserId() {
        var _a;
        return (_a = this.cookies) === null || _a === void 0 ? void 0 : _a.userId;
    }
    getGroups() {
        var _a;
        const groups = (_a = this.cookies) === null || _a === void 0 ? void 0 : _a.groups;
        if (!groups)
            return [];
        try {
            return JSON.parse(groups);
        }
        catch (err) {
            return [];
        }
    }
    isBrandEnterprise() {
        return this.getGroups().includes(AuthGroup.BrandEnterprise);
    }
    isBrandAdmin() {
        return this.getGroups().includes(AuthGroup.BrandAdmin);
    }
    isBrandUser() {
        return this.getGroups().includes(AuthGroup.BrandUser);
    }
    isBrandOwner() {
        return this.getGroups().includes(AuthGroup.Brand);
    }
    isBrand() {
        return this.isBrandOwner() || this.isBrandAdmin() || this.isBrandUser() || this.isBrandEnterprise();
    }
    isAdmin() {
        const groups = this.getUserGroups();
        return groups.includes(AuthGroup.Admin) || groups.includes(AuthGroup.SuperAdmin);
    }
    isCreator() {
        const groups = this.getUserGroups();
        return groups.includes(AuthGroup.Creator);
    }
    isClipReviewer() {
        const groups = this.getUserGroups();
        return groups.includes(AuthGroup.ClipReviewer);
    }
    isAuthenticated() {
        return !!this.getAuthToken();
    }
    getUserGroups() {
        const token = this.getAuthToken();
        if (!token)
            return [];
        const tokenDecoded = jwtDecode(token);
        return tokenDecoded.groups;
    }
    getQuery() {
        return this.ctx.query;
    }
    getRecordId() {
        const { recordId } = this.getQuery();
        return recordId;
    }
    getHeaders() {
        return this.ctx.req.headers;
    }
    getHeader(key) {
        const header = this.ctx.req.headers[key];
        if (!header) {
            return null;
        }
        return header;
    }
    getCookie(key) {
        const cookie = this.cookies[key];
        if (!cookie) {
            return null;
        }
        return cookie;
    }
    getHost() {
        // 'host' on localhost
        // 'weglot-forwarded-host' for production. Read more https://developers.weglot.com/proxy/headers
        // 'Viewer-Host' need to handle en.{domainName} domain and it used on dev stacks
        if (isLocalhost || isLocalEnv) {
            return this.getHeader('host');
        }
        return this.getHeader('weglot-forwarded-host') || this.getHeader('Viewer-Host');
    }
}
